export const FabIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="51"
      height="32"
      viewBox="0 0 51 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M49.7196 15.0277C50.0356 14.8193 50.2625 14.5619 50.4008 14.2543C50.539 13.9472 50.608 13.5655 50.608 13.1091C50.608 12.509 50.4243 12.0108 50.0581 11.6143C48.9725 14.8096 46.3271 18.2091 42.5476 21.3181H45.587C47.4729 21.3181 48.7615 20.8919 49.4528 20.0393C49.9365 19.4545 50.1787 18.6613 50.1787 17.6598C50.1787 17.0948 50.0231 16.6537 49.712 16.3364C49.4008 16.0191 48.9788 15.7861 48.4455 15.6375L48.4604 15.489C48.9344 15.4197 49.354 15.266 49.7196 15.028V15.0277Z"
        fill="white"
      />
      <path
        d="M8.71113 10.7005H2.9736L0.949402 21.3186C1.79934 17.8659 4.57334 14.1091 8.71078 10.7002L8.71113 10.7005Z"
        fill="white"
      />
      <path
        d="M26.5096 20.3516H20.8812L20.2146 21.3184H13.6676L15.4839 18.7754H7.35771L6.86882 21.3184H0.94938C0.618135 23.0554 0.580714 24.7151 1.19851 26.2152C3.99815 33.016 17.2109 33.9556 30.7101 28.3136C35.3014 26.3947 39.3342 23.9616 42.5476 21.3184H26.8204L26.5093 20.3516H26.5096Z"
        fill="white"
      />
      <path d="M24.6285 14.8198L22.7769 17.5413H25.606L24.7321 14.8198H24.6285Z" fill="white" />
      <path
        d="M17.1485 14.4479H8.18722L7.95023 15.6673H16.4226L15.9403 18.1362L21.2513 10.7002H29.4423L32.7527 20.5877L34.656 10.7002H47.0981C48.3125 10.7002 49.2013 10.9159 49.7643 11.3472C49.8731 11.4304 49.9708 11.5198 50.0585 11.6148C50.7632 9.54 50.8107 7.5515 50.0834 5.78461C47.2838 -1.01614 34.0711 -1.95577 20.5718 3.68618C15.9694 5.60962 11.9283 8.05002 8.71112 10.7005H17.8595L17.1485 14.4483V14.4479Z"
        fill="white"
      />
      <path
        d="M43.4544 13.541H40.0328L39.7663 14.9092H43.1879C43.5434 14.9092 43.805 14.8052 43.9731 14.5968C44.1113 14.4285 44.1806 14.2597 44.1806 14.0914C44.1806 13.7247 43.9384 13.541 43.4547 13.541H43.4544Z"
        fill="white"
      />
      <path
        d="M42.9356 17.1543H39.3363L39.055 18.6116H42.6394C43.0341 18.6116 43.3157 18.5027 43.4838 18.2846C43.543 18.2052 43.5922 18.1162 43.6317 18.0167C43.6712 17.9179 43.691 17.8285 43.691 17.7492C43.691 17.3526 43.4391 17.1543 42.9356 17.1543Z"
        fill="white"
      />
    </svg>
  );
};
